module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ibox-content no-padding"
  }, [_c('ul', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "list-group"
  }, _vm._l((_vm.plugins), function(plugin, index) {
    return _c('li', {
      key: plugin.id,
      staticClass: "list-group-item"
    }, [_c('span', {
      staticClass: "label label-success pull-right"
    }, [_vm._v("Enabled")]), _vm._v(" "), _c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(plugin.plugin_display))]), _vm._v(" "), _c('p', {
      staticClass: "text-muted p-xs"
    }, [_vm._v("\n          " + _vm._s(_vm.pluginDescriptions[plugin.plugin_route]) + "\n        ")])])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-title"
  }, [_c('h5', [_vm._v("Plugins")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-content ibox-heading"
  }, [_vm._v("\n    To activate plugins please contact us at\n    "), _c('a', {
    attrs: {
      "href": "mailto:support@colonyhq.com"
    }
  }, [_vm._v("support@colonyhq.com")]), _vm._v("\n    so that we can assist you in activating some of the great plugins we have to offer.\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2db674bb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/plugin/PluginList.vue
// module id = 3200
// module chunks = 3